<template>
  <div class="newsList">
    <div class="contentrows_box">
      <div class="head">
        <img src="@/assets/back.png" class="back" type="primary" @click="goBack">
      </div>
      <div style="margin: 20px 30px 0 30px;">
        <div class="title_box">
          <div class="title">基本信息</div>
        </div>

        <div class="achi_box">
          <el-form-item label="标题">

              <el-input    v-model="title" placeholder="请输入标题" clearable />

          </el-form-item>
          <el-form-item label="成果类别">

            <el-input    v-model="acType" placeholder="请输入成果类别" clearable />

          </el-form-item>
          <div class="tag_box" >

            <div class="in_label" >关键词</div>
              <div style="display:inline-block;">
                <el-tag
                    size="medium"
                    style="height:30px;"
                    :key="tag"
                    v-for="tag in dynamicTags"

                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
                  {{tag}}
                </el-tag>
<!--                <el-input-->
<!--                    class="input-new-tag"-->
<!--                    v-if="inputVisible"-->
<!--                    v-model="inputValue"-->
<!--                    ref="saveTagInput"-->
<!--                    size="normal"-->
<!--                    @keyup.enter.native="handleInputConfirm"-->
<!--                    @blur="handleInputConfirm"-->
<!--                >-->
<!--                </el-input>-->
                <el-autocomplete
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    value-key="name"
                    :onkeyup="input= input.replace(/[ ]/g,'')"
                    :fetch-suggestions="querySearchSync"
                    placeholder="请输入类型"
                    :trigger-on-focus="false"
                    size="normal"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                ></el-autocomplete>
                <el-button v-if="inputVisible" class="button-new-tag"  @click="handleInputConfirm">添加</el-button>
                <el-button v-else class="button-new-tag"  @click="showInput">添加类型</el-button>
              </div>


          </div>

          <el-form-item label="解决的问题">

              <el-input  type="textarea" autosize  v-model="solveQuestions" placeholder="请输入解决的问题" clearable />

          </el-form-item>
          <el-form-item label="先进性">

              <el-input  type="textarea" autosize v-model="advancement" placeholder="请输入先进性" clearable />

          </el-form-item>
          <el-form-item label="研究形式">

              <el-input  type="textarea" autosize v-model="researchForm" placeholder="请输入研究形式" clearable />

          </el-form-item>
          <el-form-item label="获奖情况">

              <el-input  type="textarea" autosize  v-model="awards" placeholder="请输入获奖情况" clearable />

          </el-form-item>
          <el-form-item label="市场前景分析">

              <el-input  type="textarea" autosize  v-model="prospect" placeholder="请输入市场前景分析" clearable />

          </el-form-item>
          <el-form-item label="推广应用情况">

              <el-input  type="textarea" autosize  v-model="application" placeholder="请输入推广应用情况" clearable />

          </el-form-item>
          <el-form-item label="经济效益">

              <el-input  type="textarea" autosize v-model="economicPerformance" placeholder="请输入经济效益" clearable />

          </el-form-item>
          <el-form-item label="社会生态效益">

              <el-input  type="textarea" autosize v-model="socialBenefits" placeholder="请输入社会生态效益" clearable />

          </el-form-item>
          <el-form-item label="可转化方式">

              <el-input  type="textarea" autosize v-model="convertibleMode" placeholder="请输入可转化方式" clearable />

          </el-form-item>
          <el-form-item label="转化所需资金投入(万元)">

              <el-input  type="textarea" autosize v-model="needMoney" placeholder="请输入转化所需资金投入" clearable />

          </el-form-item>
          <el-form-item label="联系人">

              <el-input  type="textarea" autosize v-model="contact" placeholder="请输入联系人" clearable />

          </el-form-item>
          <el-form-item label="联系地址">

              <el-input  type="textarea" autosize v-model="contactAddress" placeholder="请输入联系地址" clearable />

          </el-form-item>
          <el-form-item label="联系电话">

              <el-input  type="textarea" autosize v-model="contactNumber" placeholder="请输入联系电话" clearable />

          </el-form-item>
        </div>

        <div>
          <ckeditor :editor="editor" v-model="content" :config="editorConfig" :class="ck-editor__editable"></ckeditor>
          <el-button type="success" @click="admit">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import time from '@/core/time.js';
import ClassicEditor from "@/ckeditor/ckeditor";

//import FileUpload from "@enzomoraes/ckeditor5-file-upload";
export default {
  data() {
    return {
      title:'',
      content:'',

      id:'',
      input:'',
      editor: ClassicEditor,

      dynamicTags: [],
      deletedTags: [],
      originTags: [],
      inputVisible: false,
      inputValue: '',
      result: [],
      // info:{
      //   name:''
      // },

      acType:'',
      solveQuestions:'',
      advancement:'',
      researchForm:'',
      awards:'',
      prospect:'',
      application:'',
      economicPerformance:'',
      socialBenefits:'',
      convertibleMode:'',
      needMoney:'',
      contact:'',
      contactAddress:'',
      contactNumber:'',


      editorConfig: {
        min_height: 800,
        // extraPlugins : 'FileUpload',
        // The configuration of the editor.
        toolbar: ['heading', '|', 'bold', 'italic', 'alignment', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'outdent', 'indent', '|', 'uploadImage','mediaEmbed','insertTable', '|', 'undo', 'redo'],
        simpleUpload: {
          uploadUrl: '/api3/config/fileInfo/uploadImg',
          withCredentials: false,
        },
        mediaEmbed: {   // 视频配置
          previewsInData: true,
          providers: [
            {
              name: 'myprovider',
              url: [
                /^lizzy.*\.com.*\/media\/(\w+)/,
                /^www\.lizzy.*/,
                /(http|https):\/\/([\w.]+\/?)\S*/
              ],
              html: match => {
                //获取媒体url
                const input = match['input'];
                return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 70%;">' +
                    // 'video controls="controls" autoplay name="media" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"'+
                    // `source src="${input}" type="video/mp4"`+
                    // '/video'+
                    `<iframe src="${input}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
                    '</iframe>' +
                    '</div>'
                );
              }
            }
          ]
        },
      },
      editorData: '',


      totalNum: 0, pageNum: 1, pageSize: 6,
      news: [],
    }
  },
  watch: {},
  created() {
    this.id = this.$route.query.id;
    console.log(this.id);
    this.newsSelect();

    this.tagInit();
    // this.result.push({name:'aaa'})
    // this.result.push({name:'bbb'})
    // console.log("================",this.result)

  },
  mounted() {

  },
  methods: {


    admit() {
      //debugger
      if(this.title==''&&this.content==''){
        this.$msg.warning('请输入标题和正文')
      }else if(this.title==''&&this.content!=''){
        this.$msg.warning('请输入标题')
      }else if(this.title!=''&&this.content==''){
        this.$msg.warning('请输入正文')
      }else {
        let data ={
          id:this.id,
          arTag:this.dynamicTags,
          deletedTag:this.deletedTags,
          title:this.title,
          content:this.content,
          acType:this.acType,
          solveQuestions:this.solveQuestions,
          advancement:this.advancement,
          researchForm:this.researchForm,
          awards:this.awards,
          prospect:this.prospect,
          application:this.application,
          economicPerformance:this.economicPerformance,
          socialBenefits:this.socialBenefits,
          convertibleMode:this.convertibleMode,
          needMoney:this.needMoney,
          contact:this.contact,
          contactAddress:this.contactAddress,
          contactNumber:this.contactNumber,
        }
        let url = '/PageNews/UpdatePage'
        this.$request.post(url,data).then(res=>{
          console.log(res);
          this.$msg.success('提交成功');
          setTimeout(()=>{
            //需要延迟的代码 :1秒后延迟跳转到首页，可以加提示什么的
            this.$router.push({
              path: '/myAchievement',
            })
            //延迟时间：1秒
          },1000);
        })

      }
    },

    tagInit(){
      if(this.id == undefined)
      {
        return 1;
      }
      let data = {
        id:this.id,
        type:1,
      }
      let url = '/keyword/getKeywordByAchiId';
      this.$request.post(url,data).then(data =>{
        console.log("1111111111111111111111"+data);
        for (var i = 0; i < data.obj.length; i++) {
          this.originTags[i] = data.obj[i].name;
          this.dynamicTags[i] = data.obj[i].name;
        }

      })
    },
    tagSearch(value){
      let tag = value;
      let url = '/keyword/getKeywordByArTag';
      this.$request.post(url,tag).then(data =>{
        console.log("22222222222222222222222222222222222222"+data);
        return data.obj;
      })
    },

    newsSelect() {
      if(this.id == undefined)return 1;
      let data = {
        id: this.id,
      };
      let url = '/PageNews/getPageById';
      this.$request.post(url, data).then(data => {
        this.news = data.obj.news;
        this.title = this.news.title;
        this.content = this.news.content;
        this.acType=this.news.acType;
        this.solveQuestions=this.news.solveQuestions;
        this.advancement=this.news.advancement;
        this.researchForm=this.news.researchForm;
        this.awards=this.news.awards;
        this.prospect=this.news.prospect;
        this.application=this.news.application;
        this.economicPerformance=this.news.economicPerformance;
        this.socialBenefits=this.news.socialBenefits;
        this.convertibleMode=this.news.convertibleMode;
        this.needMoney=this.news.needMoney;
        this.contact=this.news.contact;
        this.contactAddress=this.news.contactAddress;
        this.contactNumber=this.news.contactNumber;
      })
    },
    showNews(value) {
      this.$router.push({
        path: '/newsShow',
        query: {
          id: value.id,
        }
      })
    },
    handleClose(tag) {
      if(this.originTags.indexOf(tag)!=-1){
        this.deletedTags.push(tag);
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      if(this.inputValue==''){}

      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    querySearchSync(queryString, cb) {
      this.result=[];
      let tag = queryString;
      // console.log('================================',tag)
      let url = '/keyword/getKeywordByArTag';
      this.$request.post(url,tag).then(data =>{
        this.result.push({"name":queryString})
        for (var i = 0; i < data.obj.length; i++) {
          let name = data.obj[i].name
          if(name === queryString)continue;
          console.log('--------------',name,i)
          this.result.push({"name":name})
          // this.result.info[i] = "name:"+data.obj[i].name;
        }
        console.log("================",this.result)

        cb(this.result);
        // clearTimeout(this.timeout);
        // this.timeout = setTimeout(() => {
        //   cb(data.obj);
        // }, 3000 * Math.random());
      })
      // var results = this.tagSearch(queryString);
      // console.log(results[1].name);
      //
      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //   cb(results);
      // }, 3000 * Math.random());
    },


  }
}
</script>
<style lang="less">

.ck-editor__editable {
  min-height: 400px;
}
.head{
  .back{
    margin-left: 30px;
    margin-top: 20px;
    width: 80px;
    height: 40px;
  }
  .back:hover{
    cursor: pointer;
  }
}

.newsList {
  width: 100%;
  height: 100%;
  background: white;

  .contentrows_box {
    height: 99%;
    border-radius: 20px;
    background: white;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 2.5%;
    box-shadow: 0px 0px 10px 0 #d0d2d3;
    .achi_box{
      label{
        /*右对齐*/
        display: inline-block;
        float: left;
        width: 200px;
        height: 20px;
        text-align: right;
      }

      .tag_box{
        margin-top: 20px;
        margin-bottom:20px;
        .el-tag + .el-tag {
          margin-left: 10px;
        }
        .button-new-tag {
          margin-left: 10px;
          height: 30px;
          line-height: 30px;
          padding-top: 0;
          padding-bottom: 0;
        }
        .input-new-tag {
          width: 180px;
          margin-left: 10px;
          height: 30px;
          line-height: 30px;
          vertical-align: bottom;
        }
        .in_label{
          margin-top:5px;
          display: inline-block;
          float: left;
          width: 190px;
          height: 20px;
          text-align: right;
          margin-right: 10px;
        }


        .row_box{
          display: inline-block;
          float: left;
          width: 200px;
          height: 20px;
        }
      }
    }
    .contentrows {
      margin: auto;
      width: 860px;
      padding-top: 50px;

      .row_box {
        width: 860px;
      }

      .row {
        height: 80px;
        width: 840px;
        border-bottom: 2px dotted #D4D4DC;

        .row_date {
          display: flex;
          float: left;
          width: 82px;

          .row_date_left {
            height: 60px;
            margin-top: 20px;
            font-size: 35px;
            line-height: 70px;
          }

          .row_date_right {
            height: 40px;
            margin-top: 34px;
            padding-left: 5px;

            .row_date_month {
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }

            .row_date_year {
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }


        .el-button {
          background: #3A63B3;
          height: 20px;
          width: 80px;
          margin-top: 45px;
          margin-right: 30px;
          font-size: 13px;
          line-height: 2px;
          border-radius: 0;
          float: right;
        }
      }

    }

    .page {
      height: 100px;
      width: 860px;
      margin: auto;
      position: relative;

      .el-pager {
        li {
          border: 1px solid #dcdfe6;
          margin-right: 10px;
          background-color: white;
        }

        li:not(.disabled).active {
          background-color: #3A62FE;
          color: white;
        }

        li:hover {
          color: #3A62FE;
        }
      }

      .btn-prev {
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        margin-left: 10px;
        background-color: white;
      }

      .btn-next {
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        background-color: white;
      }

      .el-pagination {
        position: absolute;
        bottom: 30px;
        right: 0;

        .el-pagination__sizes {
          float: right;

          .el-input  __inner {
            color: #5D61AA;
            font-weight: bold;
          }
        }
      }
    }
  }
}

</style>
